import { render, staticRenderFns } from "./douyin_portrait.vue?vue&type=template&id=13e2807e&scoped=true"
import script from "./douyin_portrait.vue?vue&type=script&lang=js"
export * from "./douyin_portrait.vue?vue&type=script&lang=js"
import style0 from "./douyin_portrait.vue?vue&type=style&index=0&id=13e2807e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2807e",
  null
  
)

export default component.exports